const onlyNumbers = (value) => String(value).replace(/[^0-9]+/g, '');

export default onlyNumbers;
